<template>
<div>
		<sub-header bizCd="10"/>
	 	<div class="sub_visual sub10">
            <div class="container">
                <div class="sub_txt">
                    <div class="tit">보도자료</div>
                    <div class="comment">언론에 소개된 에듀윌의 다양한 소식을 만나보세요.</div>
                </div>
            </div>
        </div>
        <div class="contents aos-all">
            <div class="container">
                <div class="sec">
                    <h3>보도자료</h3>
                    <div class="board">
                        <div class="board_header">
                           <h4>에듀윌, ESG 평가서 우수 등급 획득…교육업계 최고 수준</h4>
                            <!-- <div class="board_meta">
                                <ul>
                                    <li>등록일 : 22.05.24</li>
                                    <li>조회수 : 142</li>
                                </ul>
                            </div> -->
                        </div>
                      <div class="board_body">
                            <div class="board_content">
                                <figure class="image"><img
                                        src="//img.eduwill.net/resources/b2b/dev/images/img_report_05.jpg"></figure>
                                <br>
                                <br>
                                종합교육기업 에듀윌(대표 권대호)은 최근 나이스평가정보㈜로부터 ESG 평가를 받아 ESG2 등급을 부여받았다고 16일 밝혔다.
                                <br>
                                <br>
                                나이스평가정보는 환경(Environment), 사회(Social), 지배구조(Governance)로 나눠 기업의 비재무적 성과를 측정해 등급을 부여한다.
                                등급은 ESG1~ESG7까지이며, ESG1 등급은 ESG 기회 및 리스크 관리 ‘탁월’ 평가를 받고 2등급은 ESG 기회 및 리스크 관리 ‘우수’ 평가를
                                받는다. 3등급은 ESG 기회 및 리스크 관리 양호, 4등급은 보통, 5등급은 다소 미흡, 6등급은 취약, 7등급은 매우 취약 평가를 받는다.
                                <br>
                                <br>
                                에듀윌이 이번에 부여받은 ESG2 등급은 ESG 기회 및 리스크 관리가 ‘우수’하다는 평가를 받은 것으로, 교육업계 타 기업들이 다른 기관의 ESG 평가에서
                                7단계 등급 가운데 4~6등급에 머무른 것과 비교해 월등히 우수한 평가다.
                                <br>
                                <br>
                                에듀윌이 이 같이 우수한 평가등급을 받은 것은 교육업계에서 드물게 사내 ESG위원회를 운영하면서 ESG 경영에 힘을 쏟고 있기 때문으로 풀이된다.
                                <br>
                                <br>
                                에듀윌은 지난해 기존 사회공헌위원회를 ESG위원회로 개편, 환경 및 윤리경영을 강화하고 기업의 사회적 책임을 다하고 있다. 특히 ESG경영 슬로건을
                                ‘Eduwill Share for Growth(함께 하는 성장을 위한 에듀윌의 나눔)’으로 정하고, ▲임직원 및 지역사회의 올바른 환경의식 고취를 위한 활동을
                                전개해 의식 개선을 바탕으로 환경보호 실천기회 제공(환경) ▲꾸준한 기부를 통한 성장의 기반을 마련해 꿈을 현실로 만들 교육 기회를 제공(사회) ▲지속 성장을
                                위한 윤리경영을 실천해 고객과 협력업체의 불이익 방지를 위한 소통확대(지배구조) 활동을 지속할 방침이다.
                                <br>
                                <br>
                                권대호 에듀윌 대표는 “에듀윌은 회사 설립 초기부터 꾸준히 사회공헌활동을 진행하면서 한번 시작한 활동은 계속한다는 모토로 지속적인 사회적 책임을 다해오다
                                지난해 ESG위원회로 확대 개편하면서 본격 ESG경영에 힘쓴 결과 이번 우수 평가를 받은 것으로 생각된다”며 “에듀윌은 지속가능한 경영을 실현하기 위해 환경과
                                사회공헌, 지배구조 등 ESG경영을 회사운영의 주요 지표로 삼겠다”고 말했다.
                            </div>
                        </div>
                        <div class="board_nav">
                            <ul>

                                <!-- 이전 보도 기사가 있을 경우 -->
                              <li class="prev">
                                <router-link to="/edu/newsRelease/promotionVideo/news10" data-value="315283">
                                  <strong>이전</strong>
                                  <span>에듀윌-육군본부, 육군 장병 취업역량 강화 '맞손'</span>
                                </router-link>
                              </li>

                                <!-- //이전 보도 기사가 있을 경우 -->

                                <!-- 다음 보도 기사가 있을 경우 -->
                                <li class="next">
                                    <router-link to="/edu/newsRelease/promotionVideo/news6" data-value="315283">
                                        <strong>다음</strong>
                                        <span>에듀윌, 대한민국 일자리 으뜸기업에 세 번째 선정</span>
                                    </router-link>
                                </li>
                                <!-- //다음 보도 기사가 있을 경우 -->
                            </ul>
                        </div>
                        <div class="board_footer">
                            <div class="button-area">
                                <router-link to="/edu/newsRelease/main" class="lg-btn">
                                목록으로
                                </router-link>                                
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import SubHeader from "@/layouts/SubHeader";

export default {
	name: "MainOnlineEdu",
	components: {SubHeader},
	data() {
		return {
			swiper : ""
		}
	},
	
	computed: {
	},
	
	methods: {
	},
	
	created() {
	},
	beforeMount() {
	},
	mounted() {
		AOS.init({ easing: 'ease-in-out-sine' })
		
		this.swiper = new Swiper("#vi-role.swiper-container", {
	        loop: true,
	        loopFillGroupWithBlank: true,
	        navigation: {
	          nextEl: ".swiper-button-next",
	          prevEl: ".swiper-button-prev"
	        }
	    });
		
		$(".pa_slider_scroll").simplyScroll({
	        customClass:'vert',
			speed: 5,
	        pauseOnHover : true
	    });
	},
	beforeDestroy() {
	},
	destroyed() {
	}
}
</script>
